import { z } from "zod";

export enum ESupportType {
  TECHNICAL_ASSISTANCE_NOT_URGENT = "TECHNICAL_ASSISTANCE_NOT_URGENT",
  TECHNICAL_ASSISTANCE_URGENT = "TECHNICAL_ASSISTANCE_URGENT",
  CLAIM = "CLAIM",
  PLANIF_NOT_URGENT = "PLANIF_NOT_URGENT",
  PLANIF_URGENT = "PLANIF_URGENT",
  IV_TECH_NOT_URGENT = "IV_TECH_NOT_URGENT",
  IV_TECH_URGENT = "IV_TECH_URGENT",
  AIRRIA_NOT_URGENT = "AIRRIA_NOT_URGENT",
  AIRRIA_URGENT = "AIRRIA_URGENT",
  CIRCET_NOT_URGENT = "CIRCET_NOT_URGENT",
  CIRCET_URGENT = "CIRCET_URGENT",
  S30_NOT_URGENT = "S30_NOT_URGENT",
  S30_URGENT = "S30_URGENT",
  BUGBUSTERS_NOT_URGENT = "BUGBUSTERS_NOT_URGENT",
  BUGBUSTERS_URGENT = "BUGBUSTERS_URGENT",
  PAC = "PAC",
  PSB = "PSB",
  CLIMATISATION = "CLIMATISATION",
  TERTIAIRE = "TERTIAIRE",
}

export const supportTypeDtoSchema = z.object({
  id: z.number(),
  note: z.nativeEnum(ESupportType),
});

export type TSupportTypeDto = z.infer<typeof supportTypeDtoSchema>;
